import React from 'react'

import OurCommitmentPage from './our-commitment-page'

export default function OurCommitment() {
    return <OurCommitmentPage />
}
